import React, { useEffect, useState } from "react"
import Logo from 'images/integria-logo-dark.png'
import { useParams } from "react-router-dom"
import MixtureImage from 'images/mixture_image.png'
import { ChatBubbleOvalLeftEllipsisIcon, EnvelopeIcon } from '@heroicons/react/24/solid'

export default function TransactionSummaryPage() {
  let { id } = useParams()
  const [transaction, setTransaction] = useState(null)
  console.log(transaction)

  useEffect(() => {
    document.documentElement.style.setProperty('--body-bg-color', 'white');
  }, [])

  useEffect(() => {
    fetch(`/api/transactions/summary/${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch transaction')
        }
        return response.json()
      })
      .then(data => {
        console.log(data)
        setTransaction(data)
      })
  }, [id])

  if (!transaction) {
    return <div>Loading...</div>
  }

  return (
    <div className="bg-white ">
      <Header />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <OrderConfirmation transaction={transaction} />
            <CustomerInformation transaction={transaction} />
          </div>
          <div>
            <OrderItems transaction={transaction} />
            <OrderSummary transaction={transaction} />
          </div>
        </div>
        <Footer transaction={transaction} />
      </div>
    </div>
  )
}

function Header() {
  return (
    <div className="flex justify-center">
      <img
        src={Logo}
        className="object-center object-contain h-20 mb-20"
        alt="Integria Logo"
      />
    </div>
  )
}

function OrderConfirmation({ transaction }) {
  return (
    <div className="max-w-xl border-b border-gray-200 pb-6">
      {/* <h1 className="text-base font-medium ">Payment Successful</h1>
      <p className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">Thanks for ordering</p> */}
      <p className="text-base text-integria-green">
        Hi {transaction.patient.first_name},<br />
        Thank you for your order #{transaction.id}. A confirmation e-mail will be sent to {transaction.patient_email} shortly.<br /><br />
        Once your order is shipped, we will send you an email with tracking details. Please note that Liquid Mixtures are shipped separately.<br /><br />
        Feel free to visit the main <a href="/faq" className="underline">frequently asked questions</a> page if you have any queries or need more information.
      </p>
    </div>
  )
}

function Footer({ transaction }) {

  const company_code = transaction.practitioner.company_code
  const contact_email = company_code == 'inzl' ? 'ordersnz@integria.com' : 'orders@integria.com'
  const contact_phone = company_code == 'inzl' ? '0800 48 33 66' : '1300 654 336'
  const live_chat_url = company_code == 'inzl' ? 'https://nz.integria.com' : 'https://au.integria.com'


  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="">
        <a className="flex flex-nowrap items-center gap-2" href={`mailto:${contact_email}`}>
          <EnvelopeIcon className="h-12 w-12 text-gray-500" />
          <span className="text-gray-500">Contact us</span>
        </a>
      </div>
      <div className="flex flex-nowrap items-center gap-2">
        <a className="flex flex-nowrap items-center gap-2" href={live_chat_url} target="_blank">
          <ChatBubbleOvalLeftEllipsisIcon className="h-12 w-12 text-gray-500" />
          <span className="text-gray-500">Live Chat</span>
        </a>
      </div>
      <div className="flex items-center gap-2">
        <span className="font-bold text-gray-500">{contact_phone}</span>
        <span>Contact us</span>
      </div>
    </div>
  )
}

function OrderItems({ transaction }) {
  return (
    <div>
      <h2 className="mb-4">Order Summary</h2>
      {[
        ...transaction.transaction_items.filter(item => !item.mixture_transaction_item_id),
        ...transaction.mixture_transaction_items
      ].map((item) => (
        <OrderItem key={item.id} item={item} />
      ))}
    </div>
  )
}

function OrderItem({ item }) {
  const isMixture = item.transaction_items;
  const subtext = isMixture
    ? item.transaction_items
      .map(child => `${child.product_name.split(' 1:')[0]} ${child.quantity}ml`)
      .join(', ')
    : '';

  const image_url = isMixture ? MixtureImage : item.image_url;

  return (
    <div className="flex space-x-6 border-b border-gray-200 py-10">
      <img
        src={image_url}
        alt={item.product_name}
        className="h-20 w-20 flex-none rounded-lg bg-gray-100 object-contain object-center p-2"
      />
      <div className="flex flex-auto flex-col">
        <div>
          <div className="flex gap-2 items-center">
            <h4 className="text-base font-medium text-gray-900">{item.product_name || item.mixture.name}</h4>
            {isMixture && (
              <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600">
                Herbal Formulation
              </span>
            )}
          </div>
          <p className="mt-2 text-sm text-gray-600">{subtext}</p>
        </div>
        <div className="mt-6 flex flex-1 items-end">
          <dl className="flex space-x-4 divide-x divide-gray-200 text-sm sm:space-x-6">
            <div className="flex">
              <dt className="font-medium text-gray-900">Quantity</dt>
              <dd className="ml-2 text-gray-700">{item.quantity}</dd>
            </div>
            <div className="flex pl-4 sm:pl-6">
              <dt className="font-medium text-gray-900">Price</dt>
              <dd className="ml-2 text-gray-700">${parseFloat(item.patient_price).toFixed(2)}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}

function CustomerInformation({ transaction }) {
  return (
    <div>
      <h3 className="sr-only">Your information</h3>
      <AddressInformation transaction={transaction} />
    </div>
  )
}

function AddressInformation({ transaction }) {
  const { patient } = transaction;
  
  const formatAddress = (address) => {
    return [
      address.address,
      address.suburb,
      `${address.city}${address.postcode ? `, ${address.postcode}` : ''}`,
      address.country
    ].filter(Boolean).join(', ');
  };

  const billingAddress = patient.billing_address || patient.shipping_address;

  return (
    <div>
      <dl className="grid grid-cols-2 gap-x-6 py-10 text-sm">
        <div>
          <dt className="font-medium text-gray-900">Delivery address</dt>
          <dd className="mt-2 text-gray-700">
            <address className="not-italic">
              <span className="block">{patient.first_name} {patient.last_name}</span>
              <span className="block">{formatAddress(patient.shipping_address)}</span>
              {patient.shipping_address.business && (
                <span className="block">{patient.shipping_address.business}</span>
              )}
            </address>
          </dd>
        </div>
        <div>
          <dt className="font-medium text-gray-900">Billing address</dt>
          <dd className="mt-2 text-gray-700">
            <address className="not-italic">
              <span className="block">{patient.first_name} {patient.last_name}</span>
              <span className="block">{formatAddress(billingAddress)}</span>
              {billingAddress.business && (
                <span className="block">{billingAddress.business}</span>
              )}
            </address>
          </dd>
        </div>
      </dl>
      <dl className="grid grid-cols-2 gap-x-6 py-10 text-sm">
        <div>
          <dt className="font-medium text-gray-900">Payment details</dt>
          <dd className="mt-2 text-gray-700">
            <span className="block">Credit/Debit card</span>
          </dd>
        </div>
        <div>
          <dt className="font-medium text-gray-900">Practitioner details</dt>
          <dd className="mt-2 text-gray-700">
            <span className="block">{transaction.practitioner.name}</span>
            <span className="block">{transaction.practitioner.email}</span>
          </dd>
        </div>
      </dl>
    </div>
  )
}

function OrderSummary({ transaction }) {
  const taxRate = parseFloat(transaction.tax_rate);
  const paymentAmount = parseFloat(transaction.payment_amount);
  const shippingPrice = parseFloat(transaction.shipping_price);
  const subtotal = paymentAmount / (1 + taxRate) - shippingPrice;
  const taxAmount = paymentAmount - subtotal;

  return (
    <div className="sm:ml-40 sm:pl-6">
      <h3 className="sr-only">Summary</h3>
      <dl className="space-y-6 border-t border-gray-200 pt-10 text-sm">
        <div className="flex justify-between">
          <dt className="font-medium text-gray-900">Subtotal</dt>
          <dd className="text-gray-700">${subtotal.toFixed(2)}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="flex font-medium text-gray-900">Shipping</dt>
          <dd className="text-gray-700">${shippingPrice.toFixed(2)}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="font-medium text-gray-900">Tax ({(taxRate * 100).toFixed(0)}%)</dt>
          <dd className="text-gray-700">${taxAmount.toFixed(2)}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="font-medium text-gray-900">Total</dt>
          <dd className="text-gray-900">${paymentAmount.toFixed(2)}</dd>
        </div>
      </dl>
    </div>
  )
}
